import axiosPublicClient from "../../../../axiosPublicClient"

const service = async (data) => {
    const result = await axiosPublicClient.post(`/submit-pre-check-consent-and-start-session`, data)

    return result.data
}

export default service
